<template>
  <div :class="isCrm">
    <b-card>
      <b-overlay :show="!loaded || deleting" rounded="sm">
        <div class="col-md-12 d-flex title-bar-block">
          <div class="icon-block me-4">
            <button v-b-tooltip.hover id="close-label-btn" :title="$backLabel()" @click="cancel">
              <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="text">
            <span class="me-2">{{ title }}</span>
          </div>
        </div>
        <b-tabs class="mt-3" align="center" card>
          <b-tab :title="assetName" active class="p-0">
            <b-card-body class="p-0">
              <b-form @submit.stop.prevent="onSubmit"  @keydown="handleKeyDown" class="crm-activity form-sample p-0">
                <b-form-row align-h="center">
                  <b-row class="filter-form p-0" v-for="n in 2" :key="n + 'type'" :keyy="n + 'type'">
                    <div v-for="(d_item, i) in formFields[
    n == 1 ? 'evenList' : 'oddList'
  ]" class="col-12 mt-3"
                      :class="{ 'col-md-12': (d_item.field === 'order_template_id' || d_item.field === 'section_scheduling'), 'col-md-8': (d_item.field === 'master_item_id'), 'col-md-2': (d_item.type === 'check'), 'col-md-4': (d_item.type !== 'check') }"
                      :key="`${n} type ${i} group`" :id="d_item.field">
                      <template v-if="d_item.field === 'section_scheduling'">
                        <hr />
                        <h3>{{ $translate(d_item.label) }}</h3>
                      </template>
                      <label v-if="d_item.field !== 'section_scheduling'" :for="'input-' + d_item.field"
                        class="mb-3"><strong>{{
    getLabel(d_item.label)
  }}<span class="red" v-if="d_item.required">*</span></strong>
                      </label>
                      <master-item-type-ahead v-if="d_item.field ==
    'master_item_id'" key="majorItems" :disabled="isView" v-model="model[d_item.field]" :is-bundled-only="false"
                        :is-product-only="true" :parent-searched-text.sync="searchText"
                        :item-type-id.sync="p_order_item_type_id"></master-item-type-ahead>
                      <customer-type-ahead v-if="d_item.field == 'customer_id'" :key="locationRefreshCounter"
                        :required="d_item.required" v-model="model[d_item.field]" :disabled="isView" />
                      <location-section :sectionOnly="true"
                        @set-location-section="(evt) => { setLocationData(evt, 'model') }" ref="locationSectionRef"
                        v-model="model.location_section_id" :hide-controls="true" :disabled="isView"
                        v-else-if="d_item.field == 'location_section_id'" title="" :modal-title="$translate('location')"
                        :is-modal="true" :customer_id="model?.customer_id ?? -1">
                        <template #default="{
    setSearchMode,
    hideModal,
    setLocation
  }"> <b-card-footer>
                            <div class="d-flex gap-2 mb-3 mt-3 justify-content-center">

                              <b-button id="set-location-btn" v-show="!isView" @click="setLocation()" v-if="hasPermissionUpdate"
                                variant="info">{{
    $translate("ok") }}</b-button>
                              <b-button id="cancel-location-btn" class="mr-2" variant="info" @click="hideModal()">{{ $cancelLabel() }}</b-button>
                              <b-button id="location-list-btn" v-show="!isView" @click="setSearchMode()" v-if="hasPermissionUpdate"
                                variant="info">{{ $translate("locations") }}
                              </b-button>

                            </div>
                          </b-card-footer>
                        </template>
                      </location-section>
                      <select-order-template v-else-if="d_item.field == 'order_template_id'"
                        :assetClass="'form-control'" v-model="model[d_item.field]" :isAsset="true" :toggle-active="!crm"
                        :disabled="isView" include-order-type :is-required="crm" />
                      <contact-selection v-else-if="d_item.field == 'customer_contact_id'" :id="'input-' + d_item.field"
                        v-model="model[d_item.field]" :required="d_item.required"
                        :disabled="isView || !model.customer_id" :customer_id="model.customer_id">
                        {{
    `${$translate("select")} ${getLabel(d_item.label)}`
  }}
                      </contact-selection>

                      <b-col class="dd" v-else-if="d_item.type === 'select'">
                        <b-form-select class="form-control" :id="'input-' + d_item.field" v-model="model[d_item.field]"
                          :required="d_item.required" v-custom-validation="d_item.required ? $selectRequired() : ''
    " :options="getOptions(d_item.field)" :disabled="isView || is_one_off_linked(d_item.field)">
                          <template #first>
                            <b-form-select-option :value="null" :disabled="d_item.required">
                              {{
    `${$translate("select")} ${getLabel(
      d_item.label
    )}`
  }}
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-col>

                      <link-modal v-else-if="d_item.type === 'url'" v-model="model[d_item.field]"
                        :key="model[d_item.field]" :disabled="isView"></link-modal>

                      <b-form-textarea :disabled="isView" v-else-if="d_item.type === 'textarea'"
                        :id="'input-' + d_item.field" v-model="model[d_item.field]" :required="d_item.required"
                        v-custom-validation="d_item.required ? $textRequired() : ''
    " :placeholder="`${$translate('enter')} ${getLabel(
    d_item.label
  )}`" rows="3" max-rows="6">
                      </b-form-textarea>
						<div v-else-if="d_item.type === 'check'">
						<div class="form-check d-inline-block" >
                                              <label class="form-check-label me-3">
                                                  <input type="checkbox" class="form-check-input top-2"
                                                      :id="'input-' + d_item.field" 
                                                      :disabled="isView || (d_item.disabled || false)"
                                                      v-model="model[d_item.field]" :name="'input-' + d_item.field"
                                                      :value="1" :unchecked-value="0" />
                                                      <i class="input-helper"></i>
                                                    </label>
                                                  </div>
                                                  <a v-if="d_item.field == 'is_rented' && rented_activity" @click="openActivity" class="link-info position-absolute" style="cursor:pointer;">
                                                    {{ rented_activity.reference_no }}
                                                  </a>
                                                  </div>
                      <b-form-input :disabled="isView || is_one_off_linked(d_item.field) || (d_item?.disabled || false)" v-else-if="d_item.type !== '' && d_item.label != 'item'"
                        :type="d_item.type" :id="'input-' + d_item.field" v-model="model[d_item.field]"
                        :required="d_item.required" :min="d_item?.min" v-custom-validation="d_item.required ? $textRequired() : ''
    " :placeholder="`${$translate('enter')} ${getLabel(
    d_item.label
  )}`" trim>
                      </b-form-input>
                    </div>
                  </b-row>
                </b-form-row>
                <b-form-row class="mt-3">
                  <b-row>
                    <b-col cols="12">
                      <view-attachments :view-mode="isView" :is-new="isNew" />
                    </b-col>
                  </b-row>
                </b-form-row>
                <AssetSchedule v-if="!!model.id" :asset-id="id" :view-mode="viewMode" :is-new="isNew" :crm="crm"/>
                <b-form-row class="pt-0 mt-5 p-3">
                  <b-col cols="12">
                    <div class="d-flex gap-2 justify-content-center">
                      <b-button id="view-item-btn" size="fw" v-if="!!model.id" variant="info" :disabled="loading"
                        v-show="hasPermissionView" @click="isView = !isView">{{
    isView ? $translate("edit") : $translate("view")
  }}</b-button>
                      <b-button  id="save-item-btn"  size="fw" variant="info" :disabled="loading" type="submit" v-if="!isView">
                        {{
    model.id && !loading
      ? $updateLabel()
      : !model.id && loading
        ? $translate("creating")
        : model.id && loading
          ? $translate("updating")
          : $createLabel()
                        }}
                      </b-button>
                      <b-button  id="delete-item-btn"  size="fw" v-if="this.model.id && hasPermissionDelete" @click="deleteAsset()"
                        variant="delete-button">
                        {{
                        `${deleting ? $translate("deleting") : $deleteLabel()
                        } ${assetName}`
                        }}
                      </b-button>
                      <b-button  id="cancel-item-btn"  size="fw" variant="info" :disabled="!!loading" @click="cancel">
                        {{ $cancelLabel() }}
                      </b-button>
                    </div>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-card-body>
          </b-tab>
          <b-tab :title="$translate('service_history')" class="p-0" :disabled="!isView">
            <service-list-items :id="id" ref="table" :title="title" :items="asset_orders" :rows="rows">
            </service-list-items>
          </b-tab>
          <b-tab v-if="model.can_be_rented" :title="$translate('asset_rental_history')" class="p-0" :disabled="!isView">
            <ServiceRentalItem :id="id" ref="table" :title="title" :items="asset_orders" :rows="rows">
            </ServiceRentalItem>
          </b-tab>
        </b-tabs>
      </b-overlay>
    </b-card>
  </div>
</template>
<script>
import ServiceListItems from "./ServiceListItems";
import MasterItemTypeAhead from "@/components/MasterItemTypeAhead";
import CustomerTypeAhead from "@/components/CustomerTypeAhead";
import SelectOrderTemplate from "@/components/SelectOrderTemplate";
import assetMixins from "@/mixins/assetMixins";
import popupMixins from "@/mixins/popupMixins";
import utilityMixins from "@/mixins/utilityMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import locationMixins from "@/mixins/locationMixins"
// import _ from 'lodash'
// import showItemHelper from '@/mixins/showItemHelpe
import moment from "moment";
import LocationSection from "@/views/Location/LocationSection";
import LinkModal from "@/components/LinkModal";
import ContactSelection from "@/components/ContactSelection.vue";
import ServiceRentalItem from "./ServiceRentalItem";
import AssetSchedule from "./AssetSchedule.vue";
import ViewAttachments from "./ViewAttachments.vue";
// const tomorrow_date = new Date().toISOString().split("T")[0];
const dataItems = [
  //mandatory  but must be automated
  { field: "type_id", label: "type", type: "select", required: true },
  {
    field: "interaction_type_id",
    label: "interaction_type",
    type: "select",
    required: false,
  },
  { field: "model_no", label: "model_no", type: "text" },
  {
    field: "manufacturer_id",
    label: "manufacturer",
    type: "select",
    required: true,
  },
  //optional that will be ignored
  { field: "vendor_id", label: "vendor", type: "select", required: true },
  { field: "notes", label: "notes", type: "textarea" },
  { field: "serial_no", label: "serial_no", type: "text" },
  { field: "name", label: "name", type: "text", required: true },
  { field: "description", label: "description", type: "text" },
  { field: "customer_id", label: "customer", type: "custom", required: true },
  {
    field: "location_section_id",
    label: "location_section",
    type: "custom",
    required: true,
  },
  {
    field: "customer_contact_id",
    label: "customer_contact",
    type: "custom",
    required: false,
  },
  { field: 'master_item_id', label: 'item', type: 'custom', required: false },
  { field: 'can_be_rented', label: 'can_be_rented', type: 'check', required: false },
  { field: 'is_rented', label: 'is_rented', type: 'check', required: false, disabled: true },
  { field: "manual_url", label: "manual", type: "url" },
  { field: "service_plan_url", label: "service_plan", type: "url" },
  // { field: "image_url", label: "image", type: "url" },
  {
    field: "default_engineer_id",
    label: "default_engineer",
    type: "select",
    required: false,
  },
  {
    field: "warranty_expiry_date",
    label: "warranty_expiry_date",
    type: "date",
  },
    {
    field: "contract_expiry_date",
    label: "contract_expiry_date",
    type: "date",
    required: false,
  },
  // {
  //   field: "section_scheduling",
  //   label: "scheduling_heading",
  //   type: "",
  //   required: false,
  // },
  // { field: "frequency", label: "frequency", type: "select", required: true },
  // { field: "last_service_date", label: "last_service_date", type: "date" },
  // {
  //   field: "next_service_date",
  //   label: "next_service_date",
  //   type: "date",
  //   min: tomorrow_date,
  // },
  // {
  //   field: "service_week_day",
  //   label: "service_week_day",
  //   type: "select",
  //   required: false,
  // },
  // {
  //   field: "service_time_of_day",
  //   label: "service_time_of_day",
  //   type: "time",
  //   required: false,
  // },
  // {
  //   field: "contract_expiry_date",
  //   label: "contract_expiry_date",
  //   type: "date",
  //   required: false,
  // },
  // {
  //   field: "order_template_id",
  //   label: "activity_template",
  //   type: "custom",
  //   required: false,
  // },
];

const crm_fields = [
  { field: "name", label: "task_title" },
  { field: "interaction_type_id", label: "interaction_type" },
  {
    field: "default_engineer_id",
    label: "officer",
    required: true,
    type: "select",
  },
  { field: "customer_id", label: "customer" },
  {
    field: "customer_contact_id",
    label: "customer_contact",
    required: false,
  },
  { field: "location_section_id", label: "customer_address" },
  { field: "notes", label: "notes", type: "textarea" },
  // {
  //   field: "section_scheduling",
  //   label: "scheduling_heading",
  //   type: "",
  //   required: false,
  // },
  // { field: "frequency", label: "frequency", type: "select" },
  // { field: "last_service_date", label: "last_visit", type: "date" },
  // {
  //   field: "next_service_date",
  //   label: "next_visit",
  //   type: "date",
  //   min: tomorrow_date,
  // },
  // { field: "service_week_day", label: "week_day", type: "select" },
  // { field: "service_time_of_day", label: "time_of_day", type: "time" },
  // {
  //   field: "contract_expiry_date",
  //   label: "exp_date",
  //   type: "date",
  //   required: true,
  // },
  // { field: "order_template_id", label: "activity_templates", required: true },
];

const generateEmptyForm = () => {
  return dataItems.reduce(
    (_form, item) => {
      _form[item.field] = null;
      return _form;
    },
    { id: 0 }
  );
};

const model = generateEmptyForm();
export default {
  name: "assets-ViewItem",

  components: {
    LocationSection,
    ServiceListItems,
    LinkModal,
    MasterItemTypeAhead,
    CustomerTypeAhead,
    SelectOrderTemplate,
    ContactSelection,
    ServiceRentalItem,
    AssetSchedule,
    ViewAttachments
  },
  mixins: [popupMixins, assetMixins, utilityMixins, permissionsMixins, locationMixins],

  data() {
    return {
      asset_order_visible_array: [...Array(1000).keys()].map(() => false),
      viewMode : true,
      isNew : false,
      deleting: false,
      newMasterItem: null,
      isError: false,
      locationRefreshCounter: 0,
      locationState: false,
      model,
      loaded: false,
      query: "",
      searchText: null,
      rented_activity: null,
      p_order_item_type_id: null,
      loading: false,
      hasErrors: false,
      isView: false,
      uploadModal: false,
    };
  },
  props: ["id", "crm", "officers", "types"],

  computed: {
    componentName() {
      return this.$translate("asset");
    },

    master_fields() {
      return [
        {
          key: "id",
          label: this.$translate("actions"),
        },
        {
          key: "name",
          label: this.$translate("name"),
        },
        {
          key: "description",
          label: this.$translate("description"),
        },
        {
          key: "order_item_type_id",
          label: this.$translate("type"),
          formatter: (value, key, item) => {
            item = item || {};
            const type = item.type || {};
            return type.name;
          },
        },
      ];
    },

    service_fields() {
      return [
        {
          key: "name",
          label: this.$translate("name"),
        },
        {
          key: "order.reference_no",
          label: this.$translate("reference_no"),
          formatter: (value, key, item) => item.order.reference_no,
        },

        {
          key: "order_item_type_id",
          label: this.$translate("type"),
          formatter: (value, key, item) => item.item_type.name,
        },
        {
          key: "quantity",
          label: this.$translate("quantity"),
        },
        {
          key: "order.created_at",
          label: this.$translate("created"),
          formatter: (value, key, item) =>
            new Date(item.order.created_at).toISOString().split("T")[0],
        },

        {
          key: "order.completed_at",
          label: this.$translate("completed"),
          formatter: (value, key, item) =>
            item.order.completed_at
              ? new Date(item.order.completed_at).toISOString().split("T")[0]
              : "",
        },

        {
          key: "order_item_notes",
          label: this.$translate("notes"),
          formatter: (value, key, item) => item.task_notes, // tk: To be revisited
        },

        {
          key: "order_id",
          label: "",
        },
      ];
    },
    isCrm() {
      return this.$route.name.slice(0, 3) == "crm" ? "crm-view" : "asset-view";
    },
    user() {
      return this.$store.state.user;
    },

    formFields() {
      const list = [];
      if (this.crm) {
        for (const crm_obj of crm_fields) {
          const obj = dataItems.find((y) => y.field == crm_obj.field);
          for (const key in crm_obj) {
            this.$set(obj, key, crm_obj[key]);
          }
          list.push(obj);
        }
      } else {
        list.push(...dataItems);
      }
      // split in odd and even
      const typeObj = { oddList: [], evenList: [] };
      let isEven = true;
      for (const item of list) {
        // if (isEven) {
        //     typeObj.evenList.push(item)
        // } else {
        // }
        typeObj.oddList.push(item);
        isEven = !isEven;
      }
      return typeObj;
    },
    crmSettingValue() {
      return this.$store.getters["company/crmSettingValue"];
    },
    crmsettingsKey() {
      return this.$store.state.company.settingKeys.crmsettingsKey;
    },
    rows() {
      const _orders = [];
      if (this.services != null && this.services.length > 0) {
        for (const item of this.services) {
          if (item != null) {
            const { order } = item;
            if (order != null) {
              const _item = { ...item };

              delete _item.order;

              let idx = _orders.findIndex((x) => x.id == order.id);
              if (idx < 0) {
                order.items = [];
                order.items.push(_item);
                _orders.push(order);
              } else {
                _orders[idx].items.push(_item);
              }
            }
          }
        }
      }

      return _orders.length;
    },

    masterItems() {
      const asset = this.asset || {};
      let master_items =
        (asset.order_template && asset.order_template.items) || [];
      return master_items.map((x) => x.master_item);
    },
    asset() {
      const asset = this.$store.state.assets.asset || {};
      return asset;
    },
    services() {
      //return (this.asset.services || []).map(x => x.item)
      const _services = (
        (this.asset.services && this.asset.services) ||
        []
      ).map((x) => x.item);
      console.log("_services", _services); // tk
      return _services;
    },

    asset_orders() {
      const _orders = [];
      if (this.services) {
        for (const item of this.services) {
          if (item != null) {
            const { order } = item;
            console.log(order, "service history");
            const _item = { ...item };
            delete _item.order;
            if (order != null) {
              console.log("_orders", item);
              let idx = _orders.findIndex((x) => x.id == order.id);
              // let idx = _orders.findIndex(x => console.log("ID",x.id,order))
              console.log("idx", idx);
              if (idx < 0) {
                order.items = [];
                order.items.push(_item);
                _orders.push(order);
              } else {
                _orders[idx].items.push(_item);
              }
            }
          }
        }
      }
      return _orders;
    },

    assetName() {
      return this.crm ? this.$translate("crm_task") : this.$translate("asset");
    },

    title() {
      return this.model.id
        ? `${this.model.name}`
        : `${this.$translate("create")} ${this.assetName}`;
    },

    vendors() {
      return this.$store.state.assets.vendors;
    },

    customers() {
      return this.$store.state.customers.items;
    },

    locations() {
      return this.$store.state.locations.locations;
    },
    engineers() {
      return this.$store.getters["users/sorted_officers"];
    },
    interactionTypes() {
      return this.$store.state.interactionType.interaction_types;
    },

    orderTypes() {
      return this.$store.state.orderType.items;
    },

    customer_contacts() {
      return this.$store.getters["customers/customerUsers"];
    },

    scheduleDate() {
      return this.$store.getters["assets/getScheduleDate"];
    },
    assetAttachments() {
            return this.$store.state.assetAttachmentsStore.attachments
  },
  },
  watch: {
    "model.customer_id": async function (customer_id) {
      let customer = null;
      console.log("watch customer_id", customer_id);
      if (!this.isView) {
        this.model.customer_contact_id = null;
      }
      if (customer_id) {
        await this.$store.dispatch(`customers/fetchById`, customer_id);
        customer = this.customers.find((x) => x.id === customer_id);
        if (customer && customer.location_section_id) {
          console.log("customer", customer);
          this.model.location_section_id = customer.location_section_id;
          this.locationRefreshCounter++;
        }
      } else {
        this.$store.commit(`customers/SET_CUSTOMER`, null);
      }
      //////////////////////set taskname  if crm///////////////
      const {
        crm,
        model: { id, name },
      } = this;
      if (crm && !id && !name && customer) {
        console.log("setting name", customer);
        const { name } = customer;
        const randIdx = (Math.random() + 1).toString(36).substring(7);
        this.$set(this.model, "name", `${name}-${randIdx}`);
      }
      ///////
    },
    asset: {
      handler: function (val) {
        if (val) this.loaded = true;
      },
      deep: true,
    },


  },
  created() {
    this.$store.dispatch("users/fetchAll");
    this.$store.dispatch("orderType/fetchAll");
    setTimeout(() => {
      this.$store.dispatch("js_report/fetchCredentials");
    }, 500);
  },
  async mounted() {
    console.log("view route", this.$route);
    this.$store.dispatch("company/fetchConfiguration", this.crmsettingsKey);
    this.model = generateEmptyForm();
    if (this.id) {
      this.loaded = false;
      this.loadAsset(this.id);

      console.log('asset id',this.id);
      await this.$store.dispatch("assets/fetchAttachments", this.id);
     
    } else {
      this.loaded = true;
      this.$set(this.model, "default_engineer_id", this.user.id);
      this.$set(this.model, "next_service_date", this.scheduleDate || "");
    }

    
  },
  methods: {
    openActivity(){
      console.log(`/ams/activities/${this.rented_activity?.id}`)
      this.$router.push(`/ams/activities/${this.rented_activity?.id}`);
    },
    cancel() {
      this.$store.commit("assets/SET_ASSET", null);
      this.$store.commit("assets/clearAssetsAttachments",[]);
      this.$store.commit("assetAttachmentsStore/clearAssetAttachments",[]);
      this.$store.commit("assetScheduleStore/clearAssetSchedules", []);
      
      if (this.crm) {
        this.$router.push(`/ams/crm`);
      } else {
        this.$router.push(`/ams/assets`);
      }
    },
    getLabel(value) {
      const label =
        value == "task_title"
          ? this.crm
            ? this.$translate("task_title")
            : this.$translate("name")
          : this.$translate(value);
      return label;
    },
    formatDateTime(value) {
      const format1 = "YYYY-MM-DD HH:mm";
      var date1 = new Date(value);
      return moment(date1).format(format1);
    },
    do_toggle(index) {
      console.log(index);
      console.log(this.asset_order_visible_array[index]);
      this.asset_order_visible_array[index] = !this.asset_order_visible_array[
        index
      ];
    },
    is_one_off_linked(key) {
      const checkKeys = [
        "last_service_date",
        "contract_expiry_date",
        "service_week_day",
      ];
      const isIncluded = (key) => {
        const _is_included = checkKeys.includes(key);
        console.log({ key, _is_included });
        return _is_included;
      };
      return this.model.frequency == "0" && isIncluded(key);
    },
    IntToTimeFormat(intValue) {
      const formatInt = (_int) => {
        if (_int < 10) _int = `0${_int}`;
        else _int = _int.toString();
        return _int;
      };
      let hours = parseInt(intValue / 60, 10);
      if (hours > 23 || hours < 0) hours = 0;
      let minutes = intValue - hours * 60;

      return `${formatInt(hours)}:${formatInt(minutes)}`;
    },
    TimeFormatToInteger(_time) {
      try {
        const [hours, minutes] = _time.split(":");
        return parseInt(hours) * 60 + parseInt(minutes);
      } catch (err) {
        return null;
      }
    },

    async loadAsset(id) {
      this.loading = true;
      this.isView = true;
      try {
        await this.$store.dispatch("assets/get", id);
        await this.$nextTick();

        const { asset } = this;
        this.rented_activity = asset.rented_activity?.activity || null
        console.log("loadAsset asset", asset);
        this.model = { ...asset };
        /*  for (const key in this.asset) {
                     let value = this.asset[key]
                     if (key === 'service_time_of_day') {
                     value = this.IntToTimeFormat(value)
                     }
                     this.$set(this.model, key, value)
                     } */

        // this.$set(
        //   this.model,
        //   "service_time_of_day",
        //   this.IntToTimeFormat(asset.service_time_of_day)
        // );
        console.log("loaded model", this.model);
      } catch (error) {
        console.error(error);
        this.isError = true;
      } finally {
        this.loading = false;
      }
    },

    async onSubmit() {
      this.loaded = false;
      try {
        this.loading = true;
        console.log("starting now");
        if (this.model.frequency == "0") {
          const { next_service_date: nsd } = this.model;
          const weekday = new Date(nsd).getDay();
          this.$set(this.model, "contract_expiry_date", nsd);
          this.$set(this.model, "service_week_day", weekday);
        }
        if (this.crm) {
          const {
            crmSettingValue: { type_id, vendor_id },
            model: { contract_expiry_date },
          } = this;
          this.$set(this.model, "type_id", type_id);
          this.$set(this.model, "vendor_id", vendor_id);
          this.$set(this.model, "warranty_expiry_date", contract_expiry_date);
          this.$set(this.model, "manufacturer_id", vendor_id);
        }
        const valid = await this.$validator.validate();
        if (!valid) throw new Error(this.$translate("invalid_entry"));

        const { model, assetAttachments: attachments } = this;
        // console.log('attachemntis',attachments);
        this.checkLocationError(model, model.location_section_id);

        const { next_service_date: nsdd, order_template_id } = this.model;
        console.log("nsd", nsdd, order_template_id);
        if (nsdd && order_template_id == null) {
          throw new Error(this.$translate("order_template_id_is_required"));
        }

        if (!nsdd && order_template_id) {
          throw new Error(this.$translate("next_visit_is_required"));
        }

        console.log("valid so far");

        const payload = {
          ...this.model,
          attachments
        };

        payload.service_time_of_day = this.TimeFormatToInteger(
          payload.service_time_of_day
        );

        const id = parseInt(payload.id) || null;
        delete payload.id;
        const action = id ? "update" : "create";
        const message = id
          ? this.$translate("update_alert")
          : this.$translate("create_alert");
        const path = `assets/${action}`;
        console.log("submit payload", payload);
        console.log("submit path", path);
        const result = await this.$store.dispatch(path, { id, payload });
        // this.model = generateEmptyForm()
        if (action == "create") {
          if (this.crm) {
            this.$nextTick(() => {
              this.loadAsset(result.id);
              this.$router.push(`/ams/crm/${result.id}`);
            });
          } else {
            this.loadAsset(result.id);
            this.$router.push(`/ams/assets/${result.id}`);
          }
        }
        this.$emit("success", action, message, this.assetName);
      } catch (error) {
        this.$emit("error", error, this.assetName);
      } finally {
        this.loading = false;
        this.loaded = true;
      }
    },

    async deleteAsset() {
      const model = { ...this.model };
      // Generate and display confirmation prompt
      const title = `${this.$translate("delete")} ${this.assetName}?`;
      const message = `${this.$translate("delete_note")} ${model.name}?`;
      const result = await this.confirmMessage(title, message);
      const toastMessage = this.$translate("delete_alert");
      console.log("result", result);
      if (result) {
        try {
          this.deleting = true;
          await this.$store.dispatch("assets/delete", model.id);

          this.$emit("success", "delete", toastMessage, this.assetName);
          if (this.crm) {
            this.$router.push("/ams/crm");
          } else {
            this.$router.push("/ams/assets");
          }
        } catch (error) {
          console.error(error.data);
          this.doToast(
            this.$translate("error"),
            this.$translate("unable_alert") || error.message,
            "danger"
          );
        } finally {
          this.deleting = false;
        }
      }
    },

    setAssetLocation({ section, location }) {
      console.log("setAssetLocation-evt", { section, location });
      const { name: section_name } = section;
      location = location || section.location || {};
      this.$set(this.model, "section_name", section_name);
      this.$set(this.model, "location", location);
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    }
  },
  beforeDestroy() {
    this.model = generateEmptyForm();
  },
};
</script>
<style></style>
